import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/tr";
import "../Styles/ofislerimiz.css";
import "../Styles/kisisel-takvim.css";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Footer from "../Components/Footer";
import { ChevronLeft, ChevronRight, Link as LinkIcon, CalendarX, X, Clock, User, AlignLeft } from "lucide-react";

moment.locale("tr");

// Etkinlik kaynağı → etiket (renkler fetchEvents'teki atamayla aynı; mobil Duyurular ile aynı adlar)
const KAYNAKLAR = [
  { anahtar: "kisisel", etiket: "Kişisel", renk: "#8B4789" },
  { anahtar: "ekibim", etiket: "Ekibim", renk: "#e91e63" },
  { anahtar: "1000", etiket: "Şirket", renk: "#4caf50" },
  { anahtar: "1001", etiket: "Universal Team", renk: "#ff9800" },
  { anahtar: "referanslarim", etiket: "Referanslarım", renk: "#2196f3" },
];

const kaynakEtiketi = (evt) => {
  if (evt.team === "0") return "Kişisel";
  const k = KAYNAKLAR.find((x) => x.anahtar === evt.team);
  return k ? k.etiket : "Ekibim";
};

const saatKisa = (s) => (s ? String(s).slice(0, 5) : "");

const KisiselTakvim = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Custom Calendar states
  const [hataMsg, setHataMsg] = useState("");
  const [currentMonth, setCurrentMonth] = useState(moment().startOf("month"));
  const [selectedDate, setSelectedDate] = useState(moment().startOf("day"));
  const [aylikFiltre, setAylikFiltre] = useState(false);
  const [selectedEventModal, setSelectedEventModal] = useState(null);

  // Parse image string safely
  const getEventImage = (evt) => {
    if (!evt || !evt.originalEvent) return null;
    const imagesStr = evt.originalEvent.images;
    if (!imagesStr) return null;
    try {
      if (Array.isArray(imagesStr)) return imagesStr[0];
      const parsed = JSON.parse(imagesStr);
      return Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : null;
    } catch (e) {
      if (typeof imagesStr === 'string' && imagesStr.length > 5) return imagesStr;
      return null;
    }
  };

  const handleEventClick = async (e, evt) => {
    // Link butonuna tıklandıysa modal'ı açma
    if(e && e.target.closest('.tk-link')) return;

    if (evt.team !== "0" && evt.id) {
      // Bu bir genel takvim etkinliği (id_takvim). Detayları çekmemiz lazım (afiş için).
      setSelectedEventModal({ ...evt, loadingDetails: true });
      try {
        const token = getToken();
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getSpesificTakvim`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            token: token,
            id_takvim: evt.id
          }),
        });
        const result = await response.json();
        if (result.message === "basarili" && result.data && result.data.length > 0) {
          const specificData = result.data[0];
          setSelectedEventModal({ ...evt, originalEvent: { ...evt.originalEvent, ...specificData }, loadingDetails: false });
        } else {
           setSelectedEventModal({ ...evt, loadingDetails: false });
        }
      } catch (error) {
        console.error("Detay çekilirken hata:", error);
        setSelectedEventModal({ ...evt, loadingDetails: false });
      }
    } else {
      // Kişisel takvim etkinliği
      setSelectedEventModal(evt);
    }
  };

  useEffect(() => {
    fetchEvents(currentMonth.month() + 1, currentMonth.year());
  }, [currentMonth]);

  const getToken = () => {
    return Cookies.get("token") || "";
  };

  const fetchEvents = async (ay, yil) => {
    try {
      setLoading(true);
      setHataMsg("");
      const token = getToken();
      if (!token) {
        window.location.href = "/login";
        return;
      }

      // Hem kişisel takvimi hem de genel şirket/ekip takvimini çekip birleştiriyoruz
      const [kisiselResponse, genelResponse] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/api/kisisel-takvim/get`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            token, 
            ay: parseInt(ay), 
            yil: parseInt(yil)
          }),
        }),
        fetch(`${process.env.REACT_APP_API_URL}/api/takvimPageTakvim`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            token, 
            ay: String(ay), 
            ekip: "", 
            sehir: "" 
          }),
        })
      ]);

      const [kisiselData, genelData] = await Promise.all([
        kisiselResponse.json(),
        genelResponse.json()
      ]);

      if (kisiselData.m === "Geçersiz veya süresi dolmuş token." || genelData.m === "Geçersiz veya süresi dolmuş token.") {
        Cookies.remove("token", { path: "/" });
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      const formattedEvents = [];

      // 1. Kişisel Takvim Verilerini İşle
      if (kisiselData.m === "basarili") {
        const rawEvents = kisiselData.data || [];
        rawEvents.forEach((evt) => {
          let baslangicTarihi = moment(evt.baslangicTarih);
          let bitisTarihi = evt.bitisTarih ? moment(evt.bitisTarih) : baslangicTarihi.clone();
          let kontakIsmi = evt.tamIsim || "";
          
          let baslik = evt.baslik;
          if (!baslik && evt.idKontak) {
             baslik = `${kontakIsmi} ile görüşme`;
          }

          let color = evt.renk || "#8B4789";

          let current = baslangicTarihi.clone();
          while (current.isSameOrBefore(bitisTarihi, "day")) {
            formattedEvents.push({
              id: evt.id,
              title: baslik,
              start: current.toDate(),
              desc: evt.icerik || "",
              color: color,
              team: "0",
              toplantiLinki: evt.toplantiLinki,
              dateString: current.format("YYYY-MM-DD"),
              timeString: evt.baslangicSaat || "00:00",
              bitisSaat: evt.bitisSaat,
              idKontak: evt.idKontak || -1,
              originalEvent: evt
            });
            current.add(1, "day");
          }
        });
      }

      // 2. Genel Takvim (Afiş, Toplantı vb.) Verilerini İşle
      if (genelData.m === "basarili") {
        const rawGenel = genelData.datas || [];
        rawGenel.forEach((evt) => {
          let datePart = "";
          if (evt.date) {
            datePart = moment(evt.date).format("YYYY-MM-DD");
          } else {
            datePart = moment().format("YYYY-MM-DD");
          }
          const timePart = evt.time || "00:00";
          
          let color = "#e91e63"; // Default (Ekibim)
          if (evt.team === "1000") color = "#4caf50"; // Tiens
          else if (evt.team === "1001") color = "#ff9800"; // Universal Team
          else if (evt.team === "referanslarim") color = "#2196f3";

          formattedEvents.push({
            id: evt.id_takvim,
            title: evt.title || "",
            start: new Date(`${datePart}T${timePart}`),
            desc: evt.content || "",
            color: color,
            team: evt.team,
            toplantiLinki: evt.link || evt.toplantiLinki || evt.toplantilinki || "",
            originalEvent: evt,
            dateString: datePart,
            timeString: timePart
          });
        });
      }

      // Tarihe ve saate göre yeniden sıralayalım
      formattedEvents.sort((a, b) => a.start.getTime() - b.start.getTime());

      setEvents(formattedEvents);
      if (kisiselData.m !== "basarili" && genelData.m !== "basarili") {
        setHataMsg("Takvim şu anda yüklenemedi. Lütfen daha sonra tekrar deneyin.");
      }
    } catch (error) {
      console.error("Takvim verileri çekilirken hata:", error);
      setHataMsg("Takvim yüklenirken bir sorun oluştu. Lütfen bağlantınızı kontrol edip tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  const handlePrevMonth = () => setCurrentMonth(currentMonth.clone().subtract(1, "month"));
  const handleNextMonth = () => setCurrentMonth(currentMonth.clone().add(1, "month"));
  const bugunuGoster = () => {
    setCurrentMonth(moment().startOf("month"));
    setSelectedDate(moment().startOf("day"));
    setAylikFiltre(false);
  };
  const bugun = moment();

  // Generate calendar grid
  const startDay = currentMonth.clone().startOf("month").startOf("isoWeek"); // Monday start
  const endDay = currentMonth.clone().endOf("month").endOf("isoWeek");
  
  const calendarGrid = [];
  let day = startDay.clone();
  while (day.isBefore(endDay, "day") || day.isSame(endDay, "day")) {
    calendarGrid.push(day.clone());
    day.add(1, "day");
  }

  // Filter events for the list
  const displayEvents = events.filter(evt => {
    if (aylikFiltre) {
      // Yalnız ay değil yıl da eşleşmeli (genel takvim ucu yıl almıyor; geçen yılın aynı ayı karışıyordu)
      return moment(evt.start).isSame(currentMonth, "month");
    }
    return evt.dateString === selectedDate.format("YYYY-MM-DD");
  });

  const etkinlikResmi = selectedEventModal ? getEventImage(selectedEventModal) : null;

  return (
    <div className="tk-sayfa">
      <SubHeader />
      <Header isLoggedIn={Boolean(Cookies.get("token"))} />

      <div className="offices-header tk-bant">
        <div className="offices-header-pattern" />
        <div className="container offices-header-container text-center">
          <h6 className="offices-header-subtitle">📅 TAKVİM</h6>
          <h1 className="offices-header-title">Takvim</h1>
          <p className="offices-header-description">
            Kişisel görüşmeleriniz, ekip ve şirket etkinlikleriniz tek yerde.
          </p>
        </div>
      </div>

      <div className="container tk-icerik">
        <div className="tk-duzen">
          {/* Ay takvimi */}
          <section className="tk-kart tk-takvim">
            <div className="tk-ust">
              <h2 className="tk-ay">{currentMonth.format("MMMM YYYY")}</h2>
              <div className="tk-ust-sag">
                <button type="button" className="tk-bugun-btn" onClick={bugunuGoster}>Bugün</button>
                <button type="button" className="tk-ok-btn" onClick={handlePrevMonth} aria-label="Önceki ay"><ChevronLeft size={20} /></button>
                <button type="button" className="tk-ok-btn" onClick={handleNextMonth} aria-label="Sonraki ay"><ChevronRight size={20} /></button>
              </div>
            </div>

            <div className="tk-hafta">
              {["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"].map((d) => (
                <div key={d}>{d}</div>
              ))}
            </div>

            <div className="tk-gunler">
              {calendarGrid.map((d, i) => {
                const isCurrentMonth = d.month() === currentMonth.month();
                const isSelected = !aylikFiltre && d.isSame(selectedDate, "day");
                const isToday = d.isSame(bugun, "day");
                const dayEvents = events.filter((e) => e.dateString === d.format("YYYY-MM-DD"));

                return (
                  <button
                    type="button"
                    key={i}
                    className={`tk-gun${!isCurrentMonth ? " tk-gun-diger" : ""}${isToday ? " tk-gun-bugun" : ""}${isSelected ? " tk-gun-secili" : ""}`}
                    onClick={() => {
                      setSelectedDate(d);
                      setAylikFiltre(false);
                    }}
                  >
                    <span className="tk-gun-no">{d.date()}</span>
                    {dayEvents.length > 0 && (
                      <>
                        <span className="tk-ciplar">
                          {dayEvents.slice(0, 2).map((evt, idx) => (
                            <span key={idx} className="tk-cip" style={{ "--renk": evt.color }} title={evt.title}>
                              {evt.title}
                            </span>
                          ))}
                          {dayEvents.length > 2 && <span className="tk-cip-fazla">+{dayEvents.length - 2} daha</span>}
                        </span>
                        <span className="tk-noktalar">
                          {[...new Set(dayEvents.map((e) => e.color))].slice(0, 3).map((renk, idx) => (
                            <span key={idx} style={{ backgroundColor: renk }} />
                          ))}
                        </span>
                      </>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="tk-lejant">
              {KAYNAKLAR.map((k) => (
                <span key={k.anahtar}><i style={{ backgroundColor: k.renk }} />{k.etiket}</span>
              ))}
            </div>
          </section>

          {/* Seçili gün / ay ajandası */}
          <aside className="tk-kart tk-ajanda">
            <div className="tk-ajanda-ust">
              <div>
                <div className="tk-ajanda-etiket">{aylikFiltre ? "Bu ayın etkinlikleri" : "Seçili gün"}</div>
                <h3 className="tk-ajanda-baslik">
                  {aylikFiltre ? currentMonth.format("MMMM YYYY") : selectedDate.format("D MMMM, dddd")}
                </h3>
              </div>
              <div className="tk-segment" role="tablist">
                <button type="button" className={!aylikFiltre ? "aktif" : ""} onClick={() => setAylikFiltre(false)}>Gün</button>
                <button type="button" className={aylikFiltre ? "aktif" : ""} onClick={() => setAylikFiltre(true)}>Ay</button>
              </div>
            </div>

            <div className="tk-liste">
              {loading ? (
                <div className="tk-bos"><div className="tk-spinner" /></div>
              ) : displayEvents.length > 0 ? (
                displayEvents.map((evt, i) => (
                  <div
                    key={i}
                    role="button"
                    tabIndex={0}
                    className="tk-etkinlik"
                    style={{ "--renk": evt.color }}
                    onClick={(e) => handleEventClick(e, evt)}
                    onKeyDown={(e) => { if (e.key === "Enter") handleEventClick(e, evt); }}
                  >
                    <div className="tk-etkinlik-zaman">
                      {aylikFiltre && <span className="tk-etkinlik-tarih">{moment(evt.start).format("D MMM")}</span>}
                      <span className="tk-etkinlik-saat">{saatKisa(evt.timeString)}</span>
                      {evt.bitisSaat && <span className="tk-etkinlik-bitis">{saatKisa(evt.bitisSaat)}</span>}
                    </div>
                    <div className="tk-etkinlik-govde">
                      <span className="tk-rozet">{kaynakEtiketi(evt)}</span>
                      <h4>{evt.title || "Başlıksız etkinlik"}</h4>
                      {evt.desc && <p>{evt.desc}</p>}
                      {evt.toplantiLinki && (
                        <a href={evt.toplantiLinki} target="_blank" rel="noreferrer" className="tk-link">
                          <LinkIcon size={14} /> Bağlantıya git
                        </a>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="tk-bos">
                  <CalendarX size={40} strokeWidth={1.5} />
                  <p>
                    {hataMsg
                      ? hataMsg
                      : aylikFiltre
                        ? `${currentMonth.format("MMMM YYYY")} ayında etkinlik yok.`
                        : "Bu günde etkinlik yok."}
                  </p>
                </div>
              )}
            </div>
          </aside>
        </div>
      </div>

      {/* Etkinlik detayı */}
      {selectedEventModal && (
        <div className="tk-modal-arka" onClick={() => setSelectedEventModal(null)}>
          <div className="tk-modal" onClick={(e) => e.stopPropagation()} style={{ "--renk": selectedEventModal.color }}>
            <button type="button" className="tk-modal-kapat" onClick={() => setSelectedEventModal(null)} aria-label="Kapat">
              <X size={18} />
            </button>

            {selectedEventModal.loadingDetails ? (
              <div className="tk-modal-gorsel tk-modal-gorsel-bos"><div className="tk-spinner" /></div>
            ) : etkinlikResmi ? (
              <div className="tk-modal-gorsel">
                <img
                  src={`${process.env.REACT_APP_API_URL}/api/files/?filepath=${encodeURIComponent(etkinlikResmi.replace(/^["']+|["']+$/g, ''))}&token=${getToken()}`}
                  alt="Afiş"
                  onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }}
                />
              </div>
            ) : null}

            <div className="tk-modal-govde">
              <span className="tk-rozet">{kaynakEtiketi(selectedEventModal)}</span>
              <h2 className="tk-modal-baslik">{selectedEventModal.title || "Başlıksız etkinlik"}</h2>

              <ul className="tk-modal-bilgi">
                <li>
                  <Clock size={16} />
                  <span>
                    {moment(selectedEventModal.start).format("D MMMM YYYY, dddd")} · {saatKisa(selectedEventModal.timeString)}
                    {selectedEventModal.bitisSaat ? ` – ${saatKisa(selectedEventModal.bitisSaat)}` : ""}
                  </span>
                </li>
                {selectedEventModal.desc && (
                  <li><AlignLeft size={16} /><span>{selectedEventModal.desc}</span></li>
                )}
                {selectedEventModal.originalEvent?.publisher && (
                  <li><User size={16} /><span>Yayınlayan: {selectedEventModal.originalEvent.publisher}</span></li>
                )}
              </ul>

              {selectedEventModal.toplantiLinki && (
                <a href={selectedEventModal.toplantiLinki} target="_blank" rel="noreferrer" className="tk-modal-link">
                  <LinkIcon size={18} /> Bağlantıya git
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default KisiselTakvim;
